export function contentFormattingMacros() {
	// noop intentionally blank.
}
export function contentFormattingMacrosWRM() {
	return [
		'wr!com.atlassian.confluence.plugins.content-formatting-macros:content-formatting-macros-resources',
	];
}
